module.exports = __webpack_public_path__ + "img/img46.919daea6.png";